import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FEATURE_FLAGS } from '../../services/unleash/unleash.helpers';
import { UnleashService } from '../../services/unleash/unleash.service';

@Component({
  selector: 'app-coaching-log-smart-feedback',
  standalone: false,
  templateUrl: './coaching-log-smart-feedback.component.html',
  styleUrl: './coaching-log-smart-feedback.component.scss',
})
export class CoachingLogSmartFeedbackComponent {
  loading: boolean;

  instantFeedbackEnabled = false;

  @Input() smartFeedbackActive: boolean;

  @Input() sessionId: number;

  @Output() readonly hideSmartFeedbackEvent = new EventEmitter<boolean>();

  constructor(private featureFlagService: UnleashService) {
    this.instantFeedbackEnabled = this.featureFlagService.isEnabled(
      FEATURE_FLAGS.instantFeedbackCard
    );
  }

  toggleSmartFeedback(): void {
    this.hideSmartFeedbackEvent.emit(true);
  }
}
